<template>
  <!-- ケアオーケストレーターユーザー管理 -->
  <div id="COSettingUser">
      <div class="labelTitle lable">ケア オーケストレーター　ユーザー管理</div>
      <div class="result-area">
          <b-table
              :data="data"
              :paginated="true"
              per-page="10"
              pagination-position="both"
              default-sort="user.first_name"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page">
              <template slot-scope="props">
              <b-table-column field="名前" label="名前" width="150" centered class="breakAll">{{props.row.familyName}} {{props.row.firstName}}</b-table-column>
              <b-table-column field="ID" label="ID" width="150">{{props.row.registedCoUserId}}</b-table-column>
              <b-table-column field="メールアドレス" label="メールアドレス" width="250" class="breakAll">{{props.row.mail}}</b-table-column>
              <b-table-column field="申込み状況" label="申込み状況" width="100" centered>
                  <span :class="getTagClass4CoInternalUserStatus(props.row.applicationStatus)" style="width:100px;">{{props.row.applicationStatus | coInternalStatusFilter}}</span>
              </b-table-column>
              <b-table-column field="申込日" label="申込日" width="100" centered>{{props.row.applicationDate}}</b-table-column>
              <b-table-column field="完了日" label="完了日" width="100" centered>{{props.row.completionDate}}</b-table-column>
              </template>
          </b-table>
      </div>
  </div>
</template>

<script>
export default {
  name: "COSettingUser",
  methods: {
    doSearch: function() {
      var executeApi = this.getCoUserContentsPOST;
      var successCallBack = this.getCoUserContentsPOSTSuccess;
      var errorCallBack = this.getCoUserContentsPOSTError;
      // Web Api Call
      this.apiCall(executeApi, successCallBack, errorCallBack);
    },
    getCoUserContentsPOST: function(client) {
      return client.apis.internalCoSetting.getCoUserContentsPOST({
        body:{
          careOrchestratorInstitutionId: this.careOrchestratorInstitutionId
        }
      });
    },
    getCoUserContentsPOSTSuccess: function(result) {
      this.data = result.obj
    },
    getCoUserContentsPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
  },
  data() {
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    return {
      data: [],
      careOrchestratorInstitutionId:careOrchestratorInstitutionId,
    };
  },
  async mounted() {
    await this.doSearch();
  },
  filters: {},
  components: {
  },
};
</script>
<style lang="scss" scoped>
.urgency_caution {
    color: red;
}
.hiddenBackButton {
  width:100%;
  height: 100px;
  margin-top:5px;
  background-color: white;
  position: absolute;
  z-index: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/careorchestrator/setting/UserContents.vue